import { COMPANY_SHORT, PUBLIC_INFO, TIMELINE } from '../constants';

function AboutSection() {
  return (
    <section id="record" className="bg-white">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div>
          <p className="text-xs font-black uppercase text-teal">
            Source record
          </p>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-ink sm:text-5xl">
            Filed with the California Secretary of State.
          </h2>
          <p className="mt-5 leading-8 text-muted">
            This page summarizes public details from the Articles of
            Incorporation for {COMPANY_SHORT}. It keeps the presentation simple:
            identity, filing date, structure, and address.
          </p>
          <div className="mt-8 space-y-4 border-l border-line pl-5">
            {TIMELINE.map((item) => (
              <div
                key={item.label}
                className="relative"
              >
                <span className="absolute -left-[1.78rem] top-1.5 h-3 w-3 rounded-full bg-cyan ring-4 ring-steel" />
                <p className="text-[11px] font-black uppercase text-teal">{item.label}</p>
                <p className="mt-1 font-semibold text-ink">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          {PUBLIC_INFO.map((item) => (
            <div
              key={item.label}
              className="min-h-36 border border-line bg-paper p-6"
            >
              <p className="text-[11px] font-black uppercase text-teal">
                {item.label}
              </p>
              <p className="mt-3 text-xl font-black leading-snug text-ink">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
